
import { formatTimeToDate, numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import Operate from "models/operate.js";
import Expenses from "models/expenses";
const expenses = new Expenses();
import notVerifiedProjectMixins from "@/common/mixins/not-verified-project.js"
export default {
  mixins: [notVerifiedProjectMixins],
  data() {
    return {
      totalRevenue: '',
      totalCost: '',
      grossProfi: '',
      totalCostIncludeFreeWarehouse: '',
      totalGrossProfitIncludeFreeWarehouse: '',
      itemOrderGrossProfi: '',
      switchList: [
        { name: '科目明细', url: '/home/profitIndex/profit/account-details' },
        { name: '项目明细', url: '/home/profitIndex/profit/project-details' },
      ],
      warehouseId: "",
      date: this.timeDefault(),
      warehouseList: [],
      // 项目明细列表
      tableData: [],
      tableTitleList: [
        { prop: 'customerName', label: '客户名称', width: '', alignment: 'left' },
        { prop: 'orderNum', label: '单量', width: '', alignment: 'left' },
        { prop: 'warehouseGrossProfit', label: '仓储毛利', width: '', alignment: 'right' },
        { prop: 'operateGrossProfit', label: '操作毛利', width: '', alignment: 'right' },
        { prop: 'expressGrossProfit', label: '物流毛利', width: '', alignment: 'right' },
        { prop: 'otherCost', label: '其他成本', width: '', alignment: 'right' },
        { prop: 'otherGrossProfit', label: '其他费用', width: '', alignment: 'right' },
        { prop: 'totalGrossProfit', label: '总毛利', width: '', alignment: 'right' },
        { prop: 'unitGrossProfit', label: '每单毛利', width: '', alignment: 'right' },
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      // 是否展示人工设置
      isShowArtificialSet: false,
      // 物流费用列表
      expressFeeList: [],
      expressFeeTitle: [
        { prop: 'expressName', label: '承运商', width: '180', alignment: 'left' },
        { prop: 'orderNum', label: '单量', width: '180', alignment: 'right' },
        // {prop: 'unWeightedOrderNum', label: '未称重单量', width: '180', alignment:'left'},
        { prop: 'income', label: '运费收入', width: '180', alignment: 'right' },
        { prop: 'cost', label: '运费成本', width: '180', alignment: 'right' },
        { prop: 'grossProfit', label: '运费毛利', width: '180', alignment: 'right' },
        { prop: 'unitGrossProfit', label: '每单毛利', width: '180', alignment: 'right' },
      ],
      // 仓储费用列表
      warehouseAreaFeeList: [],
      warehouseAreaFeeListTitle: [
        { prop: 'warehouseName', label: '仓库', width: '180', alignment: 'left' },
        { prop: 'area', label: '面积', width: '180', alignment: 'right' },
        { prop: 'income', label: '仓储收入', width: '180', alignment: 'right' },
        { prop: 'cost', label: '仓储成本', width: '180', alignment: 'right' },
        { prop: 'grossProfit', label: '仓储毛利', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
      ],
      // 操作单量
      orderNum: 0,
      // 调整操作单量
      orderNumConvert: 0,
      // 操作件数
      goodsQuantity: 0,
      // 调整操作件数
      goodsQuantityConvert: 0,
      // 单均操作收入
      incomeUnitOrderNum: 0,
      // 件均操作成本
      costUnitGoodsQuantity: 0,
      // 件整单均操作成本
      costUnitGoodsQuantityConvert: 0,
      // 单均操作成本
      costUnitOrderNum: 0,
      // 调整单均操作成本
      costUnitOrderNumConvert: 0,
      // 单均操作毛利
      grossProfitUnitOrderNum: 0,
      // 调整单均操作毛利
      grossProfitUnitOrderNumConvert: 0,
      // 操作费用列表
      operateFeeList: [],
      operateFeeListTitle: [
        { prop: 'warehouseName', label: '仓库', width: '180', alignment: 'left' },
        { prop: 'income', label: '操作收入', width: '180', alignment: 'right' },
      ],
      // 索赔费用列表
      claimFeeList: [],
      claimFeeListTitle: [
        { prop: 'name', label: '名称', width: '180', alignment: 'left' },
        { prop: 'orderNum', label: '单量', width: '180', alignment: 'right' },
        { prop: 'cost', label: '金额', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
      ],
      // 其他费用列表
      otherFeeList: [],
      otherFeeListTitle: [
        { prop: 'name', label: '名称', width: '180', alignment: 'left' },
        { prop: 'income', label: '金额', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
      ],
      // 其他成本列表
      otherCostList: [],
      otherCostListTitle: [
        { prop: 'name', label: '名称', width: '180', alignment: 'left' },
        { prop: 'dayAmount', label: '金额', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
        { prop: '', label: '', width: '180', alignment: 'right' },
      ],
      costAllocationRules: 1,
      drawer: false,
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    if (this.$route.meta.menuChildName === '项目明细' || this.$route.meta.menuChildName === '科目明细') this.getWarehouse()
  },
  methods: {
    initData() {
      if (this.selectedTab === '项目明细') {
        this.getTableData();
        this.initNotVerifiedProjectList()
      } else {
        this.initDailyDetails()
      }
    },

    /**
     * @desc 获取仓库数据
     */
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.orderQuality = value.orderQuality;
            arr.push(obj);
          });
          this.warehouseList = arr;
          this.warehouseId = arr.length > 0 ? arr[0].id : ''
          this.isShowArtificialSet = true
          this.initData()
        }
      });
    },

    /**
     * @desc 获取客户数据
     */
    getTableData() {
      let warehouseId = this.warehouseId;
      let date = this.date;
      let currentPage = this.currentPage;
      Operate
        .getCustomerList(warehouseId, date, currentPage)
        .then(res => {
          if (res.success) {
            this.total = res.result.totalNum;
            let arr = []
            res.result.items.map(i => {
              let obj = {}
              obj.id = i.id
              obj.customerName = i.customerName
              obj.expressGrossProfit = numsToRMBSymbolAndMillimeter(i.expressGrossProfit)
              obj.operateGrossProfit = numsToRMBSymbolAndMillimeter(i.operateGrossProfit)
              obj.orderNum = i.orderNum
              obj.otherCost = numsToRMBSymbolAndMillimeter(i.otherCost)
              obj.otherGrossProfit = numsToRMBSymbolAndMillimeter(i.otherGrossProfit)
              obj.totalGrossProfit = numsToRMBSymbolAndMillimeter(i.totalGrossProfit)
              obj.unitGrossProfit = numsToRMBSymbolAndMillimeter(i.unitGrossProfit)
              obj.warehouseGrossProfit = numsToRMBSymbolAndMillimeter(i.warehouseGrossProfit)
              arr.push(obj)
            });
            this.tableData = arr;
          } else {
            this.$message.error(res.message);
          }
        });
    },

    /**
     * @desc 日报详情
     */
    initDailyDetails() {
      let warehouseId = this.warehouseId;
      let date = this.date;
      Operate
        .getDailyDetails(warehouseId, date)
        .then(res => {
          if (res.success) {
            let { totalIncome, totalCost, totalGrossProfit, unitTotalGrossProfit,
              expressFeeList, warehouseAreaFeeList, operateFeeList, claimFeeList,
              otherFeeList, otherCostList, totalCostIncludeFreeWarehouse,
              totalGrossProfitIncludeFreeWarehouse } = res.result
            this.totalRevenue = numsToRMBSymbolAndMillimeter(totalIncome)
            this.totalCost = numsToRMBSymbolAndMillimeter(totalCost)
            this.grossProfi = numsToRMBSymbolAndMillimeter(totalGrossProfit)
            this.itemOrderGrossProfi = numsToRMBSymbolAndMillimeter(unitTotalGrossProfit)
            this.totalCostIncludeFreeWarehouse = numsToRMBSymbolAndMillimeter(totalCostIncludeFreeWarehouse)
            this.totalGrossProfitIncludeFreeWarehouse = numsToRMBSymbolAndMillimeter(totalGrossProfitIncludeFreeWarehouse)
            let expressFeeArr = []
            expressFeeList.map(i => {
              let obj = {}
              obj.expressName = i.expressName
              obj.orderNum = i.orderNum
              obj.unWeightedOrderNum = i.unWeightedOrderNum
              obj.income = numsToRMBSymbolAndMillimeter(i.income)
              obj.cost = numsToRMBSymbolAndMillimeter(i.cost)
              obj.grossProfit = numsToRMBSymbolAndMillimeter(i.grossProfit)
              obj.unitGrossProfit = numsToRMBSymbolAndMillimeter(i.unitGrossProfit)
              expressFeeArr.push(obj)
            })
            let warehouseAreaFeeArr = []
            warehouseAreaFeeList.map(i => {
              let obj = {}
              obj.warehouseName = i.warehouseName
              obj.area = i.area
              obj.income = numsToRMBSymbolAndMillimeter(i.income)
              obj.cost = numsToRMBSymbolAndMillimeter(i.cost)
              obj.grossProfit = numsToRMBSymbolAndMillimeter(i.grossProfit)
              warehouseAreaFeeArr.push(obj)
            })
            let operateFeeArr = []
            operateFeeList.map((i, index) => {
              let obj = {}
              obj.warehouseName = i.warehouseName
              obj.income = numsToRMBSymbolAndMillimeter(i.income)
              obj.unitGrossProfit = numsToRMBSymbolAndMillimeter(i.unitGrossProfit)
              obj.tempCost = numsToRMBSymbolAndMillimeter(i.tempCost)
              obj.regularCost = numsToRMBSymbolAndMillimeter(i.regularCost)
              obj.grossProfit = numsToRMBSymbolAndMillimeter(i.grossProfit)
              operateFeeArr.push(obj)
              if (index == 0) {
                this.orderNum = i.orderNum
                this.orderNumConvert = i.orderNumConvert
                this.goodsQuantity = i.goodsQuantity
                this.goodsQuantityConvert = i.goodsQuantityConvert
                this.incomeUnitOrderNum = numsToRMBSymbolAndMillimeter(i.incomeUnitOrderNum)
                this.costUnitOrderNum = numsToRMBSymbolAndMillimeter(i.costUnitOrderNum)
                this.costUnitGoodsQuantityConvert = numsToRMBSymbolAndMillimeter(i.costUnitGoodsQuantityConvert)
                this.costUnitGoodsQuantity = numsToRMBSymbolAndMillimeter(i.costUnitGoodsQuantity)
                this.costUnitOrderNumConvert = numsToRMBSymbolAndMillimeter(i.costUnitOrderNumConvert)
                this.grossProfitUnitOrderNum = numsToRMBSymbolAndMillimeter(i.grossProfitUnitOrderNum)
                this.grossProfitUnitOrderNumConvert = numsToRMBSymbolAndMillimeter(i.grossProfitUnitOrderNumConvert)
              }
            })
            let claimFeeArr = []
            claimFeeList.map(i => {
              let obj = {}
              obj.name = i.name
              obj.orderNum = i.orderNum
              obj.cost = numsToRMBSymbolAndMillimeter(i.cost)
              claimFeeArr.push(obj)
            })
            let otherFeeArr = []
            otherFeeList.map(i => {
              let obj = {}
              obj.name = i.name
              obj.income = numsToRMBSymbolAndMillimeter(i.income)
              otherFeeArr.push(obj)
            })
            let otherCostArr = []
            otherCostList.map(i => {
              let obj = {}
              obj.id = i.id
              obj.name = i.name
              obj.dayAmount = numsToRMBSymbolAndMillimeter(i.dayAmount)
              otherCostArr.push(obj)
            })
            this.expressFeeList = expressFeeArr
            this.warehouseAreaFeeList = warehouseAreaFeeArr
            this.operateFeeList = operateFeeArr
            this.claimFeeList = claimFeeArr
            this.otherFeeList = otherFeeArr
            this.otherCostList = otherCostArr
          } else {
            this.$message.error(res.message);
          }
        });
    },

    /**
     * @desc 未核实项目
     */
    initNotVerifiedProjectList() {
      let data = {
        startDate: this.date,
        endDate: this.date,
        warehouseId: this.warehouseId
      }
      this.initNotVerifiedProject(data)
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerExpressCellClassName({ columnIndex }) {
      if (columnIndex > 0) {
        return 'right-align'
      }
    },

    headerWarehouseCellClassName({ columnIndex }) {
      if (columnIndex > 0) {
        return 'right-align'
      }
    },

    headerOperateCellClassName({ columnIndex }) {
      if (columnIndex > 0) {
        return 'right-align'
      }
    },

    headerCellClassName({ columnIndex }) {
      if (columnIndex > 1 && columnIndex < 9) {
        return 'right-align'
      }
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    timeDefault() {
      let date = new Date();
      let s1 = formatTimeToDate(date.getTime() - 86400000)
      return s1;
    },

    /**
     * @desc 搜索
     */
    searchData() {
      this.currentPage = 1;
      if (this.warehouseId && this.date) {
        this.isShowArtificialSet = true
        this.initData()
      } else {
        this.isShowArtificialSet = false
      }
    },

    reset() {
      this.warehouseId = this.warehouseList.length > 0 ? this.warehouseList[0].id : '';
      this.date = this.timeDefault();
      this.tableData = []
      this.isShowArtificialSet = false
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },

    changeCostAllocationRules() {
      let obj = this.warehouseList.find(item => { return item.id == this.warehouseId })
      this.costAllocationRules = obj.orderQuality
    },

    /**
     * @desc 导出
     */
    exportExit() {
      let warehouseId = this.warehouseId;
      let date = this.date;
      if (!this.warehouseId) {
        return this.$message.error('请选择仓库')
      }
      if (!this.date) {
        return this.$message.error('请选择日期')
      }
      Operate.getExportExcel(warehouseId, date).then((res) => {
        downLoadFileByBlob(res)
      });
    },

    /**
     * @desc 查看项目明细详情
     */
    lookCustomerOrderNums(row) {
      this.$router.push({
        path: '/home/profitIndex/customerSingleReport',
        query: {
          id: row.id,
          warehouseId: this.warehouseId,
          date: this.date
        }
      })
    },

    openNotVerifiedProject() {
      this.drawer = true
    },

    handleCloseDrawer() {
      this.drawer = false
    },
  }
};